<template>
  <div class="">
    <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="40%">
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
        label-width="120px"
      >
        <el-form-item label="原密码:" prop="oldPassword">
          <el-input
            placeholder="请输入原密码"
            v-model="ruleForm.oldPassword"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码:" prop="newPassword">
          <el-input
            placeholder="请输入新密码"
            v-model="ruleForm.newPassword"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="确认新密码:" prop="newPassword2">
          <el-input
            placeholder="请确认新密码"
            v-model="ruleForm.newPassword2"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit" class="loginBth"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { setPass } from "@/common/api";
import { validatePasswordStrength } from "@/untils/index";
export default {
  name: "SetPassword",
  props: {},
  components: {},
  data() {
    return {
      dialogFormVisible: false,
      ruleForm: {
        oldPassword: "",
        newPassword: "",
        newPassword2: "",
      },
      rules: {
        oldPassword: [
          { required: true, message: "请输入原密码", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            validator: validatePasswordStrength,
            trigger: "blur",
          },
        ],
        newPassword2: [
          { required: true, message: "请确认新密码", trigger: "blur" },
        ],
      },
      loading: false,
    };
  },
  computed: {},
  methods: {
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          const { oldPassword, newPassword, newPassword2 } = this.ruleForm;
          if (oldPassword == newPassword) {
            this.$errorMsg("新密码和原密码不能一致");
            return;
          }
          if (newPassword !== newPassword2) {
            this.$errorMsg("确认密码与新密码不一致");
            return;
          }
          this.loading = true;
          let param = {
            oldPassword,
            newPassword,
          };
          setPass(param)
            .then((res) => {
              this.loading = false;
              if (res.success) {
                this.$successMsg(res.data);
                this.dialogFormVisible = false;
              }
            })
            .catch((err) => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>


<style lang="scss" scoped>
</style>